import React, { Component } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Pagination from "react-js-pagination";
import $ from "jquery";
import Header from "../Layouts/Header";
import MenuSidebar from "../Layouts/MenuSidebar";
import { scrollToTopValidate, PageTitle } from "../Helpers/SettingHelper";
/* import { GET_VIEWdriverlist } from '../../actions'; */
import { apiUrl, mediaUrl } from "../Config/Config";
import axios from "axios";
import moment from "moment";

import {
  Row,
  Col,
  Modal,
  Table,
  OverlayTrigger,
  ButtonToolbar,
  Tooltip,
  Button,
} from "react-bootstrap";
const withRouter = (WrappedComponent) => (props) => {
  const params = useParams();
  const navigate = useNavigate();
  // etc... other react-router-dom v6 hooks

  return (
    <WrappedComponent
      {...props}
      params={params}
      navigate={navigate}
      // etc...
    />
  );
};
class View extends Component {
  constructor(props) {
    super(props);
    const driverid =
      typeof props.params.ID === "undefined" ? "" : props.params.ID;

    this.state = {
      driverid: driverid,
      driverlistview: "",
      membership_details: [],
    };

    axios.get(apiUrl + "driver/listdetail?id=" + driverid).then((res) => {
      if (res.data.status == "success") {
        const formdata = res.data.driverlist;
        if (formdata.status === "A") {
          this.setState({
            selectedOption: { value: "active", label: "Active" },
          });
        } else {
          this.setState({
            selectedOption: { value: "inactive", label: "Inactive" },
          });
        }
        this.setState({ driverlistview: res.data.driverlist, membership_details: res.data.planlist });
      }
    });
  }

 planlist() {
    var planlist = this.state.membership_details;
    if (planlist != "undefined" && planlist != null) {
      //if ( == "success"){
      if (Object.keys(planlist).length > 0) {
        const planlistDetails = planlist.map((planlist, Index) => {
          let sno = Index + 1;
          const membershipText = planlist.title? `${planlist.title} - $${planlist.amount}/${planlist.period}.`:'';
          const subscribeddate =new Date(planlist.created_date).toLocaleString("en-US", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true
                });
          return (
            
            <tr key={planlist.id}>
              <td>{sno}</td>
              <td>{subscribeddate }</td>
              <td>
                {membershipText}
              </td>

              <td>{planlist.current_status == "A" ? "Active" : "Inactive"}</td>
            </tr>
          );
        });
        return planlistDetails;
      } else {
        return (
          <tr>
            <td colspan="5" className="v-align-nr">
              No Result
            </td>
          </tr>
        );
      }
    } else {
      return (
        <tr>
          <td colspan="4" className="v-align-nr">
            No Result
          </td>
        </tr>
      );
    }
  }
  componentDidMount() {
    document.title = PageTitle("User View");
  }

  componentDidUpdate(prevProps, prevState) {}
  componentWillReceiveProps(Props) {}

  render() {
    var mobileno =
      this.state.driverlistview.mobileno === null ||
      this.state.driverlistview.mobileno === ""
        ? (this.state.driverlistview.mobileno = "N/A")
        : this.state.driverlistview.mobileno;

    if (this.state.driverlistview.status == "A") {
      var status = "Active";
    } else {
      var status = "Inactive";
    }
    var registeredDate= new Date(this.state.driverlistview.created_on).toLocaleString("en-US", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true
                });

    return (
      <div className="wrapper">
        <Header />
        <MenuSidebar
          currentpage="drivers"
          currentTab="car"
          currentSubTab="user-management"
        />

        <div className="content">
          <div className="content-wrapper">
            <div class="content-wrapper-before"></div>
            <div className="content-body">
              <div className="form-wrapper leaa-admin-head card">
                <div>
                  <a class="primary-btn" href="/drivers">Back</a>
                </div>
                <div className="title">
                  <h3>Driver Details</h3>
                </div>
                <div className="form-row">
                  <div className="details_left">
                    <div className="view-details">
                      <div className="view-details-one">
                        <p>
                          <b>
                            Driver<span>:</span>{" "}
                          </b>
                        </p>
                      </div>
                      <div className="view-details-two">
                        <p>
                          {this.state.driverlistview.firstname}{" "}
                          {this.state.driverlistview.lastname != null
                            ? this.state.driverlistview.lastname
                            : ""}
                        </p>
                      </div>
                    </div>
                    {this.state.driverlistview.c_company_name != null ? (
                      <div className="view-details">
                        <div className="view-details-one">
                          <p>
                            <b>
                              Company Name<span>:</span>{" "}
                            </b>
                          </p>
                        </div>
                        <div className="view-details-two">
                          <p>{this.state.driverlistview.c_company_name}</p>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}

                    {/* <div className="view-details">
                          <div className="view-details-one">
                              <p><b>Profile Image<span>:</span> </b></p>
                          </div>
                          <div className="view-details-two">
                         
		                          <img className="img_class" src={loaderimg} alt="" />
                          </div>
                        </div> */}
                    {/* <div className="view-details">
                          <div className="view-details-one">
                              <p><b>First Name<span>:</span> </b></p>
                          </div>
                          <div className="view-details-two">
                              <p>{this.state.driverlistview.firstname!=null?this.state.driverlistview.firstname:'N/A'}</p>
                          </div>
                        </div>
                        <div className="view-details">
                          <div className="view-details-one">
                              <p><b>Last Name<span>:</span> </b></p>
                          </div>
                          <div className="view-details-two">
                              <p>{this.state.driverlistview.lastname!=null?this.state.driverlistview.lastname:'N/A'}</p>
                          </div>
                        </div> */}

                    <div className="view-details">
                      <div className="view-details-one">
                        <p>
                          <b>
                            User Name<span>:</span>{" "}
                          </b>
                        </p>
                      </div>
                      <div className="view-details-two">
                        <p>
                          {this.state.driverlistview.username != null
                            ? this.state.driverlistview.username
                            : "N/A"}
                        </p>
                      </div>
                    </div>
                    <div className="view-details">
                      <div className="view-details-one">
                        <p>
                          <b>
                            Password<span>:</span>{" "}
                          </b>
                        </p>
                      </div>
                      <div className="view-details-two">
                        <p>
                          {this.state.driverlistview.orgpwd != null
                            ? this.state.driverlistview.orgpwd
                            : "N/A"}
                        </p>
                      </div>
                    </div>

                    <div className="view-details">
                      <div className="view-details-one">
                        <p>
                          <b>
                            Email<span>:</span>{" "}
                          </b>
                        </p>
                      </div>
                      <div className="view-details-two">
                        <p>{this.state.driverlistview.email}</p>
                      </div>
                    </div>
                    <div className="view-details">
                      <div className="view-details-one">
                        <p>
                          <b>
                            Contact<span>:</span>{" "}
                          </b>
                        </p>
                      </div>
                      <div className="view-details-two">
                        <p>{this.state.driverlistview.mobileno}</p>
                      </div>
                    </div>

                    <div className="view-details">
                      <div className="view-details-one">
                        <p>
                          <b>
                            License<span>:</span>{" "}
                          </b>
                        </p>
                      </div>
                      <div className="view-details-two">
                        <p>
                          {this.state.driverlistview.driving_license != null
                            ? this.state.driverlistview.driving_license
                            : "N/A"}
                        </p>
                      </div>
                    </div>
                    <div className="view-details">
                      <div className="view-details-one">
                        <p>
                          <b>
                            Car Number<span>:</span>{" "}
                          </b>
                        </p>
                      </div>
                      <div className="view-details-two">
                        <p>
                          {this.state.driverlistview.car_number != null
                            ? this.state.driverlistview.car_number
                            : "N/A"}
                        </p>
                      </div>
                    </div>
                    <div className="view-details">
                      <div className="view-details-one">
                        <p>
                          <b>
                            Car Color<span>:</span>{" "}
                          </b>
                        </p>
                      </div>
                      <div className="view-details-two">
                        <p>
                          {this.state.driverlistview.car_color != null
                            ? this.state.driverlistview.car_color
                            : "N/A"}
                        </p>
                      </div>
                    </div>
                    <div className="view-details">
                      <div className="view-details-one">
                        <p>
                          <b>
                            Car Image<span>:</span>{" "}
                          </b>
                        </p>
                      </div>
                      <div className="view-details-two">
                        <p>
                          {this.state.driverlistview.car_image != null
                            ? this.state.driverlistview.car_image
                            : "N/A"}
                        </p>
                      </div>
                    </div>

                    <div className="view-details">
                      <div className="view-details-one">
                        <p>
                          <b>
                            Domain<span>:</span>{" "}
                          </b>
                        </p>
                      </div>
                      <div className="view-details-two">
                        <p>{this.state.driverlistview.domain_name}</p>
                      </div>
                    </div>

                    <div className="view-details">
                      <div className="view-details-one">
                        <p>
                          <b>
                            Status<span>:</span>{" "}
                          </b>
                        </p>
                      </div>
                      <div className="view-details-two">
                        <p>{status}</p>
                      </div>
                    </div>
                       <div className="view-details">
                      <div className="view-details-one">
                        <p>
                          <b>
                            Registered On<span>:</span>{" "}
                          </b>
                        </p>
                      </div>
                      <div className="view-details-two">
                        <p>{registeredDate}</p>
                      </div>
                    </div>
                  </div>
                </div>
{this.state.membership_details.length > 0 &&(
  <>
                <div className="title">
                  <h3>Membership details</h3>
                </div>

                <div class="form-row">
                  <div class="car-listing-row">
                    <table class="table table-striped table-bordered table-hover">
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Subscribed On</th>
                          <th>Package</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                       {this.planlist()}
                      </tbody>
                    </table>
                  </div>
                </div>
</>
)}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(View);
